import { customerState } from '../redux/customerSlice/customerSlice';

export default function isCustomersBid(customer: customerState, bid: any) {
  if (!bid) {
    return false;
  }
  if (customer.id === bid.customer_id && customer.type === bid.customer_type) {
    return true;
  }
  return false;
}
